import React from "react";
const ReportIcon = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3332 4.5L18.3332 9.5V19.5H6.6665V4.5H13.3332Z" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.9165 4.5V9.08333H18.3332" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 16.1667V13.6667" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.5 16.1666V12.8333" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 16.1667V12" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default ReportIcon;
